module.exports = __webpack_public_path__ + "static/media/mobil-app-dev.32164a57.png";